// extracted by mini-css-extract-plugin
export var logo = "_iq-2";
export var logoWrapper = "_iq-1";
export var strip = "_iq-0";